module.exports = __webpack_public_path__ + "static/media/continue-to-own.dbde862b.svg";